import { configureStore } from '@reduxjs/toolkit';
import monitorReducersEnhancer from '../enhancers/monitor-reducer';
import rootReducer from '../reducers';

export default configureStore({ reducer: rootReducer, enhancers: [monitorReducersEnhancer] });
